export const UIThemesEnum = {
  DEFAULT: 0,
  HIGH_CONTRAST: 1
}

export default {
  [UIThemesEnum.DEFAULT]: [],
  [UIThemesEnum.HIGH_CONTRAST]: [
    { name: '--primary', value: 'white' },
    { name: '--secondary', value: 'white' },
    { name: '--secondary-light', value: 'white' },
    { name: '--success', value: 'green' },
    { name: '--bg-color-primary', value: 'black' },
    { name: '--bg-color-footer', value: 'white' },
    { name: '--bg-color-card', value: 'black' },
    { name: '--text-color-primary', value: 'white' },
    { name: '--gray-100', value: 'black' },
    { name: '--gray-200', value: 'black' },
    { name: '--gray-300', value: 'black' },
    { name: '--gray-500', value: 'white' },
    { name: '--gray-600', value: 'white' },
    { name: '--gray-700', value: 'white' },
    { name: '--gray-800', value: 'white' },
    { name: '--gray-900', value: 'white' },
    { name: '--neutral-color-0', value: 'white' },
    { name: '--neutral-color-1', value: 'white' },
    { name: '--neutral-color-2', value: 'white' },
    { name: '--neutral-color-3', value: 'white' },
    { name: '--neutral-color-4', value: 'gray' },
    { name: '--neutral-color-5', value: 'gray' },
    { name: '--black', value: 'white' },
    { name: '--blue', value: 'white' },
    { name: '--green', value: 'black' },
    { name: '--light-blue', value: 'white' },
    { name: '--orange', value: 'white' },
    { name: '--orange-dark', value: 'white' },
    { name: '--white', value: 'black' }
  ]
}
